import { Connector } from '@web3-react/types'
import COINBASE_ICON_URL from '../../assets/icons/coinbaseWalletIcon.svg'
import { coinbaseWalletConnection, ConnectionType } from '../connection/connection'
import { getConnectionName } from '../connection/utils'

import Option from './Option'

const BASE_PROPS = {
    icon: COINBASE_ICON_URL,
    id: 'coinbase-wallet',
}

export function OpenCoinbaseWalletOption() {
    const isActive = coinbaseWalletConnection.hooks.useIsActive()
    return (
        <Option
            {...BASE_PROPS}
            isActive={isActive}
            link="https://go.cb-w.com/dapp?cb_url=https%3A%2F%2Fapp.spritz.finance"
            header="Open in Coinbase Wallet"
        />
    )
}

export function CoinbaseWalletOption({
    tryActivation,
}: {
    tryActivation: (connector: Connector) => void
}) {
    const isActive = coinbaseWalletConnection.hooks.useIsActive()
    return (
        <Option
            {...BASE_PROPS}
            isActive={isActive}
            onClick={() => tryActivation(coinbaseWalletConnection.connector)}
            header={getConnectionName(ConnectionType.COINBASE_WALLET)}
        />
    )
}
